import { ChatController } from './chat.controller'

/* @ngInject */
function chat () {
  return {
    restrict: 'E',
    templateUrl: '/core/directives/chat/chat-directive.html?$$REVISION$$',
    controller: ChatController,
    scope: {
      emptyTitle: '@',
      emptyMessage: '@',
      theme: '@',
      inputPlaceholder: '@',
      inputPrivatePlaceholder: '@',
      inputType: '<',
      inputValue: '<',
      hasPrivate: '<',
      hasMark: '<',
      isMark: '<',
      showSeeAttachment: '<',
      task: '<',
      board: '<',
      focused: '<',
      alwaysFocused: '<',
      isPreview: '<',
      onTab: '<',
      onSend: '<',
      onMark: '<',
      onDelete: '<',
      onEdit: '<',
      onPinTimeClick: '<',
      getMessages: '<',
      updateMessages: '=',
      hoverCommentId: '=?',
      isPinning: '<'
    }
  }
}

export { chat }
